import "core-js/modules/es6.function.name";
import a from "react";
import m from "clsx";
import { HagertyLogo as s } from "../../logos/HagertyLogo";
import { HagertyLogo40 as p } from "../../logos/HagertyLogo40";
import { HagertyLogoCompact as l } from "../../logos/HagertyLogoCompact";

var h = function h(_ref) {
  var i = _ref.name,
      g = _ref.url,
      n = _ref.label,
      _ref$logo = _ref.logo,
      o = _ref$logo === void 0 ? "default" : _ref$logo,
      r = _ref.wordmark;
  return a.createElement("li", {
    className: m("hg-primarynav__item", "hg-primarynav__item--".concat(i))
  }, a.createElement("a", {
    href: g,
    "aria-label": n,
    className: m("hg-primarynav__link", "hg-primarynav__link--".concat(i))
  }, a.createElement("span", {
    className: "hg-primarynav__image--regular hg-primarynav__link-image"
  }, o === "anniversary" ? a.createElement(p, null) : a.createElement(s, null)), a.createElement("span", {
    className: "hg-primarynav__image--compact hg-primarynav__link-image"
  }, r ? a.createElement(l, null) : a.createElement(s, null)), a.createElement("span", {
    className: "hg-primarynav__link-text"
  }, n)), r && a.createElement("span", {
    className: "hg-primarynav__wordmark"
  }, r));
};

export { h as Branding };